import { memo, useRef } from 'react';
import { useSelector } from '@hotjar/recordings/src/store/player/context';
import { useResizeObserver } from '../../../../hooks/useResizeObserver';
import { PreviewContainer, PreviewCursorContainer } from '../styles';
import { PlaybackOverlays } from './PlaybackOverlays';

const SVGActions = memo(
  () => <svg id="svg-actions" />,
  () => true,
);

const ContentIFrames = memo(
  () => <div id="content-iframes" />,
  () => true,
);

const InternalPlaybackArea = () => {
  const { recording, showCursor, done } = useSelector(
    // eslint-disable-next-line @typescript-eslint/no-shadow
    ({ recording, showCursor, done }) => ({
      recording,
      showCursor,
      done,
    }),
  );

  const areaRef = useRef<HTMLDivElement>(null);
  const { width, height } = useResizeObserver(areaRef);

  const recordingWidth = recording?.window_size[0] || 1;
  const recordingHeight = recording?.window_size[1] || 1;

  const showPreviewCursor = Boolean(showCursor && !done && recording?.device === 'desktop');
  const zoom = Math.min(Math.min(width / recordingWidth, height / recordingHeight), 1);

  return (
    <div id="playback-area" ref={areaRef}>
      <PlaybackOverlays />

      <PreviewContainer id="preview-container" zoom={zoom} windowSize={recording?.window_size}>
        <PreviewCursorContainer show={showPreviewCursor} zoom={zoom}>
          <div id="preview-cursor" />
        </PreviewCursorContainer>

        <div id="svg-actions-container">
          <SVGActions />
        </div>

        <ContentIFrames />
      </PreviewContainer>
    </div>
  );
};

export const PlaybackArea = memo(InternalPlaybackArea, () => true);
